import client from '@/lib/axios-client'
import type {
	CustomerClassificationInput,
	CustomerClassificationListOutput,
	CustomerClassificationListParams,
	CustomerClassificationOutput,
} from '@/types/customer-classification'

const CUSTOMER_CLASSIFICATIONS_URL = '/customer-classifications'

export async function getCustomerClassifications(
	params?: CustomerClassificationListParams,
): Promise<CustomerClassificationListOutput> {
	const response = await client.get(CUSTOMER_CLASSIFICATIONS_URL, { params })
	return response.data.data
}

export async function createCustomerClassification(
	body: CustomerClassificationInput,
): Promise<CustomerClassificationOutput> {
	const response = await client.post(CUSTOMER_CLASSIFICATIONS_URL, body)
	return response.data.data
}

export async function updateCustomerClassification(
	id: string,
	body: CustomerClassificationInput,
): Promise<CustomerClassificationOutput> {
	const response = await client.put(
		`${CUSTOMER_CLASSIFICATIONS_URL}/${id}`,
		body,
	)
	return response.data.data
}

export async function deleteCustomerClassification(id: string): Promise<void> {
	await client.delete(`${CUSTOMER_CLASSIFICATIONS_URL}/${id}`)
}
